/* eslint-disable prettier/prettier */
import client from './_client'
import store from '../../store'
import verifyUser from '../interceptor'


client.interceptors.response.use(
    response => {
        return response
    },
    async error => {
        if (error.response?.status === 403) {
            const authToken = store.getters['auth/authToken']
            await verifyUser(authToken)
        }
        return Promise.reject(error)
    }
)

export default {
    getMyForms(isPublic) {
        return client({
            method: 'GET',
            url: `api/v1/respondent/forms`,
            headers: {
                'auth-token': store.getters['auth/authToken']
            },
            params: {
                public: isPublic
            }
        })
    },
    createUnoappRespondent() {
        return client({
            method: 'GET',
            url: `api/v1/respondent`,
            headers: {
                'auth-token': store.getters['auth/authToken'],
                'location-id': store.getters['user/selectedLocation'].id
            }
        })
    },
    getOpenSubmissions({ formId,
        page,
        searchTerm,
        tagId,
        status }) {
        return client({
            method: 'get',
            // url: `api/v1/submissions/${formId}/open?page=${page}&limit=10&search=${searchTerm}`,
            url: `api/v1/submissions/${formId}/open`,
            headers: {
                'client-token': store.getters['user/clientToken']
            },
            params: {
                page,
                limit: 10,
                search: searchTerm,
                tag_id: tagId,
                status
            }
        })
    },

    getQuestionsBySection(formId, sectionId) {
        return client({
            method: 'GET',
            url: `api/v1/submissions/forms/${formId}/?section_id=${sectionId}`,
            headers: {
                'auth-token': store.getters['auth/authToken'],
                'client-token': store.getters['user/clientToken'],
                'submission-token': store.getters['form/selectedSubmissionToken']
            }
        })
    },

    getSubmissionDetails(formId) {
        return client({
            method: 'GET',
            url: `api/v1/submissions/forms/${formId}/details`,
            headers: {
                'client-token': store.getters['user/clientToken'],
                'submission-token': store.getters['form/selectedSubmissionToken']
            }
        })
    },

    getSectionResponses(section_id) {
        return client({
            method: 'GET',
            // url: `api/v1/respondents/forms/${formId}/submission`,
            url: `api/v1/responses/?section_id=${section_id}`,
            headers: {
                'client-token': store.getters['user/clientToken'],
                'submission-token': store.getters['form/selectedSubmissionToken'],
                'auth-token': store.getters['auth/authToken']
            }
        })
    },

    getSubmissionSummary() {
        return client({
            method: 'GET',
            // url: `api/v1/respondents/forms/${store.getters['form/selectedFormId']}/summary`,
            url: `api/v1/submissions/forms/${store.getters['form/selectedFormId']}/summary`,
            headers: {
                'client-token': store.getters['user/clientToken'],
                'submission-token': store.getters['form/selectedSubmissionToken']
            }
        })
    },

    getArchivedSubmissions(formId,
        page,
        searchTerm) {
        return client({
            method: 'GET',
            url: `api/v1/submissions/${formId}/open?page=${page}&limit=10&search=${searchTerm}&status=approved`,
            headers: {
                'client-token': store.getters['user/clientToken']
            }
        })
    },
    getPublicSubmissions(formId,
        page,
        searchTerm) {
        return client({
            method: 'GET',
            url: `api/v1/submissions/${formId}/open?page=${page}&limit=10&search=${searchTerm}&status=submitted`,
            headers: {
                'client-token': store.getters['user/clientToken']
            }
        })
    },
    getDashboardStats(formId) {
        return client({
            method: 'GET',
            url: `api/v1/forms/${formId}/dashboard/summary/`,
            headers: {
                'auth-token': store.getters['auth/authToken']
            }
        })
    },

    // getAccountsByLocation(locationId) {
    //     return client({
    //         method: 'GET',
    //         url: `api/v1/account/location/${locationId}`,
    //         headers: {
    //             'auth-token': store.getters['auth/authToken']
    //         }
    //     })
    // },

    createNewSubmission(formId) {
        return client({
            method: 'POST',
            url: `api/v1/submissions/forms/${formId}`,
            headers: {
                'client-token': store.getters['user/clientToken'],
                'auth-token': store.getters['auth/authToken']
            },
            data: {
                ref_key_values: {},
                force_new: 1
            }
        })
    },

    submitSingleAnswer(data, submissionToken, formId) {
        return client({
            method: 'POST',
            url: `api/v1/submissions/forms/${formId}/answer`,
            headers: {
                'submission-token': submissionToken,
                'client-token': store.getters['user/clientToken'],
                'auth-token': store.getters['auth/authToken']
            },
            data
        })
    },

    updateAnswer(data) {
        return client({
            method: 'PATCH',
            url: 'api/v1/account/submit/answer',
            headers: {
                'submission-token': store.getters['form/selectedSubmissionToken'],
                'client-token': store.getters['user/clientToken'],
                'auth-token': store.getters['auth/authToken']
            },
            data
        })
    },

    submitMultipleAnswers(data) {
        return client({
            method: 'POST',
            url: 'api/v1/submissions/submit/answer',
            headers: {
                'submission-token': store.getters['form/selectedSubmissionToken'],
                'client-token': store.getters['user/clientToken'],
                'auth-token': store.getters['auth/authToken']
            },
            data
        })
    },

    getSubmissionStats({ submissionToken }) {
        return client({
            method: 'GET',
            url: `api/v1/submissions/status`,
            headers: {
                'submission-token': submissionToken,
                'client-token': store.getters['user/clientToken'],
                'auth-token': store.getters['auth/authToken']
            }
        })
    },
    submitSubmission({ formId }) {
        return client({
            method: 'POST',
            url: `api/v1/submissions/forms/${formId}/submit`,
            headers: {
                'submission-token': store.getters['form/selectedSubmissionToken'],
                'client-token': store.getters['user/clientToken'],
                'auth-token': store.getters['auth/authToken']
            },
        })
    },


    submitForm() {
        return client({
            method: 'POST',
            url: `api/v1/submissions/forms/${store.getters['form/selectedFormId']}/submit`,
            headers: {
                'submission-token': store.getters['form/selectedSubmissionToken'],
                'client-token': store.getters['user/clientToken']
            },
        })
    },

    approveSubmission(formId, data) {
        return client({
            method: 'POST',
            url: `api/v1/submissions/forms/${formId}/approve`,
            headers: {
                'submission-token': store.getters['form/selectedSubmissionToken'],
                'client-token': store.getters['user/clientToken'],
                'auth-token': store.getters['auth/authToken']
            },
            data
        })
    },

    updateSubmissionHoldStatus({ formId, data }) {
        return client({
            method: 'POST',
            url: `api/v1/submissions/forms/${formId}/onhold`,
            headers: {
                'submission-token': store.getters['form/selectedSubmissionToken'],
                'client-token': store.getters['user/clientToken'],
                'auth-token': store.getters['auth/authToken']
            },
            data
        })
    },

    cancelSubmission(formId) {
        return client({
            method: 'DELETE',
            url: `api/v1/submissions/forms/${formId}/cancel`,
            headers: {
                'submission-token': store.getters['form/selectedSubmissionToken'],
                'client-token': store.getters['user/clientToken'],
                'auth-token': store.getters['auth/authToken']
            },
        })
    },

    startNewFormSubmission(formId) {
        // TODO: Deal with dealer name later
        return client({
            method: 'POST',
            url: `api/v1/submissions/forms/${formId}`,
            headers: {
                'client-token': store.getters['user/clientToken']
            },
            data: {
                ref_key_values: {
                    // dealer_name: ''
                }
            }
        })
    },

    submitAnswer(data) {
        return client({
            method: 'POST',
            url: `api/v1/submissions/forms/${store.getters['form/selectedFormId']}/answer`,
            headers: {
                'submission-token': store.getters['form/selectedSubmissionToken'],
                'client-token': store.getters['user/clientToken']
            },
            data
        })
    },

    getResponsesBySection(sectionId) {
        return client({
            method: 'GET',
            url: `api/v1/responses/?section_id=${sectionId}`,
            headers: {
                'client-token': store.getters['user/clientToken'],
                'submission-token': store.getters['form/selectedSubmissionToken']
            }
        })
    },
}
